import * as React from 'react';
import { Button, toast } from '@relay-towing/ui';
import { Plus } from '@phosphor-icons/react';
import type { CallRecord } from '../calls/callRecord';
import { CreateInvoiceSheet } from '../calls/CreateInvoiceSheet';
import { CallPickerSheet } from '../shell/CallPickerSheet';

/**
 * Invoices' New, for an office member with "Create invoices": pick the call,
 * then the call's own Create invoice sheet, the same quick invoice a call
 * makes (`POST /calls/:id/invoice`). A full invoice, with its customer, tax
 * and discount, is for later (the owner, 2026-10-28). The server refuses a
 * call that already has an invoice, and says so on the sheet.
 */
export function NewInvoiceButton() {
  const [picking, setPicking] = React.useState(false);
  const [call, setCall] = React.useState<CallRecord | null>(null);
  return (
    <>
      <Button
        variant="soft"
        size="lg"
        pill
        leadingIcon={<Plus />}
        onClick={() => setPicking(true)}
      >
        New
      </Button>
      <CallPickerSheet
        open={picking}
        onOpenChange={setPicking}
        onPick={(picked) => {
          // As the call screen offers none: Urgently pays for its calls.
          if (picked.source === 'URGENTLY') {
            toast.error('Urgently pays for its calls', {
              description: 'They are not invoiced from Relay.',
            });
            return false;
          }
          setCall(picked);
        }}
      />
      {call ? (
        <CreateInvoiceSheet
          call={call}
          open
          onOpenChange={(open) => !open && setCall(null)}
        />
      ) : null}
    </>
  );
}
